const rocketEmoji = '\uD83D\uDE80';
const warningEmoji = '\u26D4';

// node v8.5 supports these methods via importing them from the 'perf_hooks' module
export const supportsUserTiming =
  typeof performance !== 'undefined' &&
  typeof performance.mark === 'function' &&
  typeof performance.clearMarks === 'function' &&
  typeof performance.measure === 'function' &&
  typeof performance.clearMeasures === 'function';

export const formatMarkName = (name: string) => `${rocketEmoji} ${name}`;

export const formatLabel = (label: string, warning: string | null) => {
  const prefix = warning
    ? `${rocketEmoji} ${warningEmoji} `
    : `${rocketEmoji} `;
  const suffix = warning ? ` Warning: ${warning}` : '';
  return `${prefix}${label}${suffix}`;
};

export const beginMark = (markName: string) => {
  performance.mark(formatMarkName(markName));
};

export const clearMark = (markName: string) => {
  performance.clearMarks(formatMarkName(markName));
};

export const endMark = (
  label: string,
  markName: string,
  warning: string | null
) => {
  const formattedMarkName = formatMarkName(markName);
  const formattedLabel = formatLabel(label, warning);

  try {
    performance.measure(formattedLabel, formattedMarkName);
  } catch (err: any) {
    // if previous mark was missing for some reason, this will throw
    // this shouldn't happen but regardless don't pile on errors.
  }

  // clear marks immediately to avoid growing buffer
  // [NOTE]: this prevents entries from being detected by a console based `performance.getEntries()` call.
  // If you need to observe performance entries outside of the timeline view
  // attach a PerformanceObserver:
  // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceObserver
  performance.clearMarks(formattedMarkName);
  performance.clearMeasures(formattedLabel);
};
